import React from 'react';
import ReactDOM from 'react-dom';
import { useVerifyServer } from '../../hooks/useVerifyServer';
import './GiftIcon.css';

export default function GiftIcon({ gift, server, showTooltip = true, size = '48px' }) {
  const serverMap  = useVerifyServer(server);
  const [show, setShow]       = React.useState(false);
  const [pos, setPos]         = React.useState({ top: 0, left: 0 });
  const wrapperRef            = React.useRef(null);

  const handleEnter = () => {
    if (!showTooltip) return;
    if (wrapperRef.current) {
      const r = wrapperRef.current.getBoundingClientRect();
      setPos({ top: r.top, left: r.left + r.width / 2 });
    }
    setShow(true);
  };

  if (!gift || gift.icon === 'npextra.png') return null;

  const giftName    = gift.name;
  const displayQty  = parseInt(giftName.match(/\[(\d+)\]/)?.[1] || '1', 10);
  const displayName = giftName.replace(/\[\d+\]/, '').trim();
  const iconUrl     = `https://wydmisc.raidhut.com.br/icons/${serverMap}/${gift.icon}`;

  return (
    <div
      ref={wrapperRef}
      className="gift-icon-wrapper"
      onMouseEnter={handleEnter}
      onMouseLeave={() => setShow(false)}
    >
      <div style={{ position: 'relative' }}>
        <img
          src={iconUrl}
          alt={displayName}
          className="gift-icon-img"
          style={{ width: size, height: size }}
        />
        {showTooltip && (
          <div className="gift-icon-badge">{displayQty}</div>
        )}
      </div>

      {show && gift.descriptionData && ReactDOM.createPortal(
        <GiftTooltip
          displayName={displayName}
          descriptionData={gift.descriptionData}
          anchorTop={pos.top}
          anchorCenterX={pos.left}
        />,
        document.body
      )}
    </div>
  );
}

function GiftTooltip({ displayName, descriptionData, anchorTop, anchorCenterX }) {
  const ref = React.useRef(null);
  const [style, setStyle] = React.useState({ visibility: 'hidden', position: 'fixed', zIndex: 99999 });

  React.useLayoutEffect(() => {
    if (!ref.current) return;
    const { width, height } = ref.current.getBoundingClientRect();
    const MARGIN = 8;
    const vw = window.innerWidth;

    let left = anchorCenterX - width / 2;
    if (left < MARGIN) left = MARGIN;
    if (left + width > vw - MARGIN) left = vw - width - MARGIN;

    const top = anchorTop - height - 10;

    setStyle({ position: 'fixed', zIndex: 99999, top, left, visibility: 'visible' });
  }, [anchorTop, anchorCenterX]);

  return (
    <div ref={ref} className="gift-icon-tooltip" style={style}>
      <p className="gift-icon-tooltip-name">{displayName}</p>
      {descriptionData.map((row, i) => {
        let color = row[0];
        if (color.length === 8) color = color.slice(0, 6);
        const isEmpty = row[1] === '';
        return (
          <p key={i} className="gift-icon-tooltip-row" style={{
            color: '#' + color,
            opacity: isEmpty ? 0 : 1,
            lineHeight: isEmpty ? '5px' : '1.4',
          }}>
            {isEmpty ? ' ' : row[1]}
          </p>
        );
      })}
    </div>
  );
}
